module.exports = __webpack_public_path__ + "img/hwc_img1.29338e25.jpg";